/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppAdminRouteImport } from './routes/_app/admin'
import { Route as AppAnalyticsRouteImport } from './routes/_app/analytics'
import { Route as AppPositionsRouteImport } from './routes/_app/positions'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as AppSnipeRouteImport } from './routes/_app/snipe'
import { Route as AppStrategyRouteImport } from './routes/_app/strategy'
import { Route as AppSystemRouteImport } from './routes/_app/system'
import { Route as AppTelegramRouteImport } from './routes/_app/telegram'
import { Route as AppTrackedRouteImport } from './routes/_app/tracked'
import { Route as AppTradesRouteImport } from './routes/_app/trades'
import { Route as AppWalletRouteImport } from './routes/_app/wallet'
import { Route as AuthCheckEmailRouteImport } from './routes/_auth/check-email'
import { Route as AuthForgotPasswordRouteImport } from './routes/_auth/forgot-password'
import { Route as AuthLoginRouteImport } from './routes/_auth/login'
import { Route as AuthResetPasswordRouteImport } from './routes/_auth/reset-password'
import { Route as AuthSignupRouteImport } from './routes/_auth/signup'
import { Route as AuthTwoFactorRouteImport } from './routes/_auth/two-factor'
import { Route as AppSettingsIndexRouteImport } from './routes/_app/settings.index'
import { Route as AppSettingsAccountRouteImport } from './routes/_app/settings.account'
import { Route as AppSettingsAdminRouteImport } from './routes/_app/settings.admin'
import { Route as AppSettingsCopyRouteImport } from './routes/_app/settings.copy'
import { Route as AppSettingsStatusRouteImport } from './routes/_app/settings.status'
import { Route as AppTokensMintRouteImport } from './routes/_app/tokens.$mint'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminRoute = AppAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AppRoute,
} as any)
const AppAnalyticsRoute = AppAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => AppRoute,
} as any)
const AppPositionsRoute = AppPositionsRouteImport.update({
  id: '/positions',
  path: '/positions',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppSnipeRoute = AppSnipeRouteImport.update({
  id: '/snipe',
  path: '/snipe',
  getParentRoute: () => AppRoute,
} as any)
const AppStrategyRoute = AppStrategyRouteImport.update({
  id: '/strategy',
  path: '/strategy',
  getParentRoute: () => AppRoute,
} as any)
const AppSystemRoute = AppSystemRouteImport.update({
  id: '/system',
  path: '/system',
  getParentRoute: () => AppRoute,
} as any)
const AppTelegramRoute = AppTelegramRouteImport.update({
  id: '/telegram',
  path: '/telegram',
  getParentRoute: () => AppRoute,
} as any)
const AppTrackedRoute = AppTrackedRouteImport.update({
  id: '/tracked',
  path: '/tracked',
  getParentRoute: () => AppRoute,
} as any)
const AppTradesRoute = AppTradesRouteImport.update({
  id: '/trades',
  path: '/trades',
  getParentRoute: () => AppRoute,
} as any)
const AppWalletRoute = AppWalletRouteImport.update({
  id: '/wallet',
  path: '/wallet',
  getParentRoute: () => AppRoute,
} as any)
const AuthCheckEmailRoute = AuthCheckEmailRouteImport.update({
  id: '/check-email',
  path: '/check-email',
  getParentRoute: () => AuthRoute,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSignupRoute = AuthSignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => AuthRoute,
} as any)
const AuthTwoFactorRoute = AuthTwoFactorRouteImport.update({
  id: '/two-factor',
  path: '/two-factor',
  getParentRoute: () => AuthRoute,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsAccountRoute = AppSettingsAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsAdminRoute = AppSettingsAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsCopyRoute = AppSettingsCopyRouteImport.update({
  id: '/copy',
  path: '/copy',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsStatusRoute = AppSettingsStatusRouteImport.update({
  id: '/status',
  path: '/status',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppTokensMintRoute = AppTokensMintRouteImport.update({
  id: '/tokens/$mint',
  path: '/tokens/$mint',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/admin': typeof AppAdminRoute
  '/analytics': typeof AppAnalyticsRoute
  '/positions': typeof AppPositionsRoute
  '/settings': typeof AppSettingsRouteWithChildren
  '/snipe': typeof AppSnipeRoute
  '/strategy': typeof AppStrategyRoute
  '/system': typeof AppSystemRoute
  '/telegram': typeof AppTelegramRoute
  '/tracked': typeof AppTrackedRoute
  '/trades': typeof AppTradesRoute
  '/wallet': typeof AppWalletRoute
  '/check-email': typeof AuthCheckEmailRoute
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/login': typeof AuthLoginRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/signup': typeof AuthSignupRoute
  '/two-factor': typeof AuthTwoFactorRoute
  '/settings/account': typeof AppSettingsAccountRoute
  '/settings/admin': typeof AppSettingsAdminRoute
  '/settings/copy': typeof AppSettingsCopyRoute
  '/settings/status': typeof AppSettingsStatusRoute
  '/tokens/$mint': typeof AppTokensMintRoute
  '/settings/': typeof AppSettingsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof AppIndexRoute
  '/admin': typeof AppAdminRoute
  '/analytics': typeof AppAnalyticsRoute
  '/positions': typeof AppPositionsRoute
  '/snipe': typeof AppSnipeRoute
  '/strategy': typeof AppStrategyRoute
  '/system': typeof AppSystemRoute
  '/telegram': typeof AppTelegramRoute
  '/tracked': typeof AppTrackedRoute
  '/trades': typeof AppTradesRoute
  '/wallet': typeof AppWalletRoute
  '/check-email': typeof AuthCheckEmailRoute
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/login': typeof AuthLoginRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/signup': typeof AuthSignupRoute
  '/two-factor': typeof AuthTwoFactorRoute
  '/settings/account': typeof AppSettingsAccountRoute
  '/settings/admin': typeof AppSettingsAdminRoute
  '/settings/copy': typeof AppSettingsCopyRoute
  '/settings/status': typeof AppSettingsStatusRoute
  '/tokens/$mint': typeof AppTokensMintRoute
  '/settings': typeof AppSettingsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/_auth': typeof AuthRouteWithChildren
  '/_app/admin': typeof AppAdminRoute
  '/_app/analytics': typeof AppAnalyticsRoute
  '/_app/positions': typeof AppPositionsRoute
  '/_app/settings': typeof AppSettingsRouteWithChildren
  '/_app/snipe': typeof AppSnipeRoute
  '/_app/strategy': typeof AppStrategyRoute
  '/_app/system': typeof AppSystemRoute
  '/_app/telegram': typeof AppTelegramRoute
  '/_app/tracked': typeof AppTrackedRoute
  '/_app/trades': typeof AppTradesRoute
  '/_app/wallet': typeof AppWalletRoute
  '/_auth/check-email': typeof AuthCheckEmailRoute
  '/_auth/forgot-password': typeof AuthForgotPasswordRoute
  '/_auth/login': typeof AuthLoginRoute
  '/_auth/reset-password': typeof AuthResetPasswordRoute
  '/_auth/signup': typeof AuthSignupRoute
  '/_auth/two-factor': typeof AuthTwoFactorRoute
  '/_app/': typeof AppIndexRoute
  '/_app/settings/account': typeof AppSettingsAccountRoute
  '/_app/settings/admin': typeof AppSettingsAdminRoute
  '/_app/settings/copy': typeof AppSettingsCopyRoute
  '/_app/settings/status': typeof AppSettingsStatusRoute
  '/_app/tokens/$mint': typeof AppTokensMintRoute
  '/_app/settings/': typeof AppSettingsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/analytics'
    | '/positions'
    | '/settings'
    | '/snipe'
    | '/strategy'
    | '/system'
    | '/telegram'
    | '/tracked'
    | '/trades'
    | '/wallet'
    | '/check-email'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/signup'
    | '/two-factor'
    | '/settings/account'
    | '/settings/admin'
    | '/settings/copy'
    | '/settings/status'
    | '/tokens/$mint'
    | '/settings/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin'
    | '/analytics'
    | '/positions'
    | '/snipe'
    | '/strategy'
    | '/system'
    | '/telegram'
    | '/tracked'
    | '/trades'
    | '/wallet'
    | '/check-email'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/signup'
    | '/two-factor'
    | '/settings/account'
    | '/settings/admin'
    | '/settings/copy'
    | '/settings/status'
    | '/tokens/$mint'
    | '/settings'
  id:
    | '__root__'
    | '/_app'
    | '/_auth'
    | '/_app/admin'
    | '/_app/analytics'
    | '/_app/positions'
    | '/_app/settings'
    | '/_app/snipe'
    | '/_app/strategy'
    | '/_app/system'
    | '/_app/telegram'
    | '/_app/tracked'
    | '/_app/trades'
    | '/_app/wallet'
    | '/_auth/check-email'
    | '/_auth/forgot-password'
    | '/_auth/login'
    | '/_auth/reset-password'
    | '/_auth/signup'
    | '/_auth/two-factor'
    | '/_app/'
    | '/_app/settings/account'
    | '/_app/settings/admin'
    | '/_app/settings/copy'
    | '/_app/settings/status'
    | '/_app/tokens/$mint'
    | '/_app/settings/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin': {
      id: '/_app/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AppAdminRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/analytics': {
      id: '/_app/analytics'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AppAnalyticsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/positions': {
      id: '/_app/positions'
      path: '/positions'
      fullPath: '/positions'
      preLoaderRoute: typeof AppPositionsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/snipe': {
      id: '/_app/snipe'
      path: '/snipe'
      fullPath: '/snipe'
      preLoaderRoute: typeof AppSnipeRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/strategy': {
      id: '/_app/strategy'
      path: '/strategy'
      fullPath: '/strategy'
      preLoaderRoute: typeof AppStrategyRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/system': {
      id: '/_app/system'
      path: '/system'
      fullPath: '/system'
      preLoaderRoute: typeof AppSystemRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/telegram': {
      id: '/_app/telegram'
      path: '/telegram'
      fullPath: '/telegram'
      preLoaderRoute: typeof AppTelegramRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tracked': {
      id: '/_app/tracked'
      path: '/tracked'
      fullPath: '/tracked'
      preLoaderRoute: typeof AppTrackedRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/trades': {
      id: '/_app/trades'
      path: '/trades'
      fullPath: '/trades'
      preLoaderRoute: typeof AppTradesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/wallet': {
      id: '/_app/wallet'
      path: '/wallet'
      fullPath: '/wallet'
      preLoaderRoute: typeof AppWalletRouteImport
      parentRoute: typeof AppRoute
    }
    '/_auth/check-email': {
      id: '/_auth/check-email'
      path: '/check-email'
      fullPath: '/check-email'
      preLoaderRoute: typeof AuthCheckEmailRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/forgot-password': {
      id: '/_auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reset-password': {
      id: '/_auth/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/signup': {
      id: '/_auth/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof AuthSignupRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/two-factor': {
      id: '/_auth/two-factor'
      path: '/two-factor'
      fullPath: '/two-factor'
      preLoaderRoute: typeof AuthTwoFactorRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_app/settings/': {
      id: '/_app/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/account': {
      id: '/_app/settings/account'
      path: '/account'
      fullPath: '/settings/account'
      preLoaderRoute: typeof AppSettingsAccountRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/admin': {
      id: '/_app/settings/admin'
      path: '/admin'
      fullPath: '/settings/admin'
      preLoaderRoute: typeof AppSettingsAdminRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/copy': {
      id: '/_app/settings/copy'
      path: '/copy'
      fullPath: '/settings/copy'
      preLoaderRoute: typeof AppSettingsCopyRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/status': {
      id: '/_app/settings/status'
      path: '/status'
      fullPath: '/settings/status'
      preLoaderRoute: typeof AppSettingsStatusRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/tokens/$mint': {
      id: '/_app/tokens/$mint'
      path: '/tokens/$mint'
      fullPath: '/tokens/$mint'
      preLoaderRoute: typeof AppTokensMintRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppSettingsRouteChildren {
  AppSettingsAccountRoute: typeof AppSettingsAccountRoute
  AppSettingsAdminRoute: typeof AppSettingsAdminRoute
  AppSettingsCopyRoute: typeof AppSettingsCopyRoute
  AppSettingsStatusRoute: typeof AppSettingsStatusRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
}

const AppSettingsRouteChildren: AppSettingsRouteChildren = {
  AppSettingsAccountRoute: AppSettingsAccountRoute,
  AppSettingsAdminRoute: AppSettingsAdminRoute,
  AppSettingsCopyRoute: AppSettingsCopyRoute,
  AppSettingsStatusRoute: AppSettingsStatusRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
}

const AppSettingsRouteWithChildren = AppSettingsRoute._addFileChildren(
  AppSettingsRouteChildren,
)

interface AppRouteChildren {
  AppAdminRoute: typeof AppAdminRoute
  AppAnalyticsRoute: typeof AppAnalyticsRoute
  AppPositionsRoute: typeof AppPositionsRoute
  AppSettingsRoute: typeof AppSettingsRouteWithChildren
  AppSnipeRoute: typeof AppSnipeRoute
  AppStrategyRoute: typeof AppStrategyRoute
  AppSystemRoute: typeof AppSystemRoute
  AppTelegramRoute: typeof AppTelegramRoute
  AppTrackedRoute: typeof AppTrackedRoute
  AppTradesRoute: typeof AppTradesRoute
  AppWalletRoute: typeof AppWalletRoute
  AppIndexRoute: typeof AppIndexRoute
  AppTokensMintRoute: typeof AppTokensMintRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAdminRoute: AppAdminRoute,
  AppAnalyticsRoute: AppAnalyticsRoute,
  AppPositionsRoute: AppPositionsRoute,
  AppSettingsRoute: AppSettingsRouteWithChildren,
  AppSnipeRoute: AppSnipeRoute,
  AppStrategyRoute: AppStrategyRoute,
  AppSystemRoute: AppSystemRoute,
  AppTelegramRoute: AppTelegramRoute,
  AppTrackedRoute: AppTrackedRoute,
  AppTradesRoute: AppTradesRoute,
  AppWalletRoute: AppWalletRoute,
  AppIndexRoute: AppIndexRoute,
  AppTokensMintRoute: AppTokensMintRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface AuthRouteChildren {
  AuthCheckEmailRoute: typeof AuthCheckEmailRoute
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthSignupRoute: typeof AuthSignupRoute
  AuthTwoFactorRoute: typeof AuthTwoFactorRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthCheckEmailRoute: AuthCheckEmailRoute,
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthSignupRoute: AuthSignupRoute,
  AuthTwoFactorRoute: AuthTwoFactorRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
